export const common = {
  actions: {
    cancel: "Cancel",
    create: "Create",
    delete: "Delete",
  },
  chat: {
    inputPlaceholder: "Type a message...",
    send: "Send",
    clear: "Clear",
  },
  status: {
    loading: "Loading...",
  },
};
